export const PRIMARY = '#00b1aa';
export const PRIMARY_LIGHT = '#e5f7f6';
export const PRIMARY_LIGHT_SECONDARY = '#f4fafa';
export const SECONDARY = '#1e958c';
export const ORANGE = '#f49d10';
export const ORANGE_SECONDARY = '#ed7422';
export const ORANGE_LIGHT = '#faf3ee';
export const GRAY = '#cccbcb';
export const GRAY_SECONDARY = '#939393';
export const GRAY_TERTIARY = '#b2b2b2';
export const GRAY_LIGHT = '#f2f2f2';
export const GRAY_LIGHT_SECONDARY = '#efefef';
export const GRAY_LIGHT_TERTIARY = '#f7f7f7';
export const RED = '#f41710';
export const RED_LIGHT = '#fef0f0';
export const TEXT = '#023850';
export const DARK = '#023850';
export const BLUE = '#0094bf';
export const BLUE_SECONDARY = '#D2EBF0';
export const BLUE_TERTIARY = '#F1F9FB';
export const BLUE_LIGHT = '#1f9bb4';
export const BLUE_DARK = '#136f8b';
export const YELLOW = '#ffd100';
export const WHITE = '#ffffff';
export const TURQUOISE = '#21a2b9';
export const MINT = '#7ac6bc';

// New UI Colors
export const NEW_RED_LIGHT = '#FFDAD6';
export const NEW_YELLOW_LIGHT = '#FFF1C2';
export const NEW_GREEN_LIGHT = '#CFF7D3';
export const NEW_PRIMARY_LIGHT = '#F2F9F7';

export const rgbaPrimary = (alpha = 1) => `rgba(0,177,170,${alpha})`;
export const rgbaBlueDark = (alpha = 1) => `rgba(19,111,139,${alpha})`;
export const rgbaOrange = (alpha = 1) => `rgba(244,157,16,${alpha})`;
